<template>
  <v-container>
    <v-row>
      <v-col class="result-display-title text-center">{{title}}</v-col>
    </v-row>

    <v-row>
      <v-col class="result-display-text text-center">{{value}}</v-col>
    </v-row>

    <v-row>
      <v-col class="result-display-change text-center">{{change}}</v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    change: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.result-display-title {
  background-color: #3300cc;
  color: #fafafa;
  font-size: 14px;
}
.result-display-text {
  background-color: white;
  color: black;
  font-size: 19px;
  font-weight: bolder;
}
.result-display-change {
  color: #3300cc;
  font-size: 13px;
  font-weight: bold;
}
</style>